export default "__VITE_ASSET__mfuFGV3i__"